import React, { useState } from 'react';
import { MAP_LAYERS } from './mapLayerRegistry';
import { activeLayers, selectLayer } from './mapLayers';

// PiP 우측 지도 패널: 지금 일차에 맞는 정보 레이어를 보여준다. 쓸 수 있는 레이어가 둘 이상이면 제목 옆에 탭이 생긴다.
// 인라인 스타일만 쓴다(PiP는 별도 창이라 CSS가 없음).
// layers는 테스트용으로 바꿀 수 있고, 평소에는 mapLayerRegistry의 MAP_LAYERS를 쓴다.
export default function PipMapPanel({ entries, current = null, layers = MAP_LAYERS }) {
  const [selectedId, setSelectedId] = useState(null);
  const available = activeLayers(layers, current);
  const layer = selectLayer(layers, current, selectedId);
  const { View } = layer;

  return (
    <div style={{ fontSize: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6, marginBottom: 4 }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>{layer.title}</div>
        {available.length > 1 && (
          <div style={{ display: 'flex', gap: 4, marginLeft: 'auto' }}>
            {available.map((l) => (
              <button
                key={l.id}
                type="button"
                onClick={() => setSelectedId(l.id)}
                style={{
                  padding: '1px 8px', borderRadius: 10, border: '1px solid #4a4a5d', cursor: 'pointer', fontSize: 11,
                  fontFamily: 'inherit', color: '#d9d9d9', background: l.id === layer.id ? '#378ADD' : '#2a2a3d',
                }}
              >
                {l.title}
              </button>
            ))}
          </div>
        )}
      </div>
      <View entries={entries} current={current} />
    </div>
  );
}
